import React from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import { HorizontalStepperType } from 'containers/SignupPages/types';
import { sanlamBlue } from 'Material-UI/colors';
import { injectIntl } from 'react-intl';
import { translate } from 'helpers/intl';
import { get } from 'lodash';
import messages from 'components/Stepper/messages';
import { StyledStepLabel, Connector } from 'components/Stepper/styles';
import StepIcon from 'components/Stepper/StepIcon';

const HorizontalStepper = ({
  stepsList,
  activeStep,
  ...otherProps
}: HorizontalStepperType) => {
  const PrimaryStepsLabelsList = stepsList
    .map(({ label }) => label)
    .filter(
      (stepLabel, currentIndex, stepList) =>
        stepList.lastIndexOf(stepLabel) === currentIndex,
    );
  return (
    <Stepper activeStep={activeStep} connector={<Connector />} alternativeLabel>
      {PrimaryStepsLabelsList.map((label) => (
        <Step key={label}>
          <StyledStepLabel StepIconComponent={StepIcon} color={sanlamBlue}>
            {translate({ ...get(messages, label) }, otherProps)}
          </StyledStepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default injectIntl(HorizontalStepper);
